export default "__VITE_ASSET__lEu1KxGN__"